module.exports = __webpack_public_path__ + "static/img/dian_icon.3afa0b82.png";